export default "__VITE_ASSET__31ccf2a4__"